import { v4 as uuidv4 } from 'uuid'

class Formula {
    constructor({
        name,
        formula = '',
    }) {
        this.id = uuidv4()
        this.name = name
        this.formula = formula
    }

    toJSON() {
        return {
            name: this.name,
            formula: this.formula,
        }
    }
}

export default Formula
